import { Kind, visit } from "graphql";
import { mapOperation, setArgInSelectionSet } from "./ast-path.js";
import { rawToValueNode } from "./arg-value.js";
function suggestVarName(doc, argName) {
  const existingNames = /* @__PURE__ */ new Set();
  for (const def of doc.definitions) {
    if (def.kind === Kind.OPERATION_DEFINITION) {
      for (const vd of def.variableDefinitions ?? []) {
        existingNames.add(vd.variable.name.value);
      }
    }
  }
  if (!existingNames.has(argName)) {
    return argName;
  }
  let i = 2;
  while (existingNames.has(`${argName}_${i}`)) {
    i++;
  }
  return `${argName}_${i}`;
}
function promoteArgToVariable(doc, path, argName, varName, type, defaultRaw, operationName) {
  const defaultValue = rawToValueNode();
  const varDef = {
    kind: Kind.VARIABLE_DEFINITION,
    variable: {
      kind: Kind.VARIABLE,
      name: {
        kind: Kind.NAME,
        value: varName
      }
    },
    type: {
      kind: Kind.NAMED_TYPE,
      name: {
        kind: Kind.NAME,
        value: type
      }
    },
    defaultValue,
    directives: []
  };
  const varValueNode = {
    kind: Kind.VARIABLE,
    name: {
      kind: Kind.NAME,
      value: varName
    }
  };
  return mapOperation(doc, operationName, (operation) => {
    const newSelectionSet = setArgInSelectionSet(operation.selectionSet, path, argName, varValueNode);
    if (newSelectionSet === operation.selectionSet) {
      return operation;
    }
    const existingVarDefs = operation.variableDefinitions ?? [];
    const variableDefinitions = existingVarDefs.some((vd) => vd.variable.name.value === varName) ? existingVarDefs : [...existingVarDefs, varDef];
    return {
      ...operation,
      variableDefinitions,
      selectionSet: newSelectionSet
    };
  });
}
function replaceVariableInSelectionSet(selectionSet, varName, defaultValue) {
  return visit(selectionSet, {
    Argument(arg) {
      if (arg.value.kind === Kind.VARIABLE && arg.value.name.value === varName) {
        return defaultValue === void 0 ? null : {
          ...arg,
          value: defaultValue
        };
      }
      return;
    }
  });
}
function demoteVariable(doc, varName, operationName, inlineValue) {
  return mapOperation(doc, operationName, (operation) => {
    const varDefs = operation.variableDefinitions ?? [];
    const targetDef = varDefs.find((vd) => vd.variable.name.value === varName);
    if (!targetDef) {
      return operation;
    }
    const value = inlineValue ?? targetDef.defaultValue;
    const newVarDefs = varDefs.filter((vd) => vd.variable.name.value !== varName);
    const newSelectionSet = replaceVariableInSelectionSet(operation.selectionSet, varName, value);
    return {
      ...operation,
      variableDefinitions: newVarDefs,
      selectionSet: newSelectionSet
    };
  });
}
export {
  demoteVariable,
  promoteArgToVariable,
  replaceVariableInSelectionSet,
  suggestVarName
};
//# sourceMappingURL=variables.js.map
